import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRoleBackground } from "../hooks/useRoleBackground";
import { useLanguage } from "../context/LanguageContext";
import icon1 from "../assets/aicom_waiting_icon1.png";
import icon2 from "../assets/aicom_waiting_icon2.png";

/**
 * AIWaitingScreen component displays a waiting screen with an animated icon and text.
 */
const AIWaitingScreen = () => {
  const { bgStyle, className } = useRoleBackground("yellow");
  const { t } = useLanguage();
  const [selectedIcon, setSelectedIcon] = useState(icon1);
  const [displayedText, setDisplayedText] = useState(
    t('aicom.selecting', 'AICOM-chan is selecting an image')
  );
  const [displayDots, setDisplayDots] = useState(true);

  const [dotCount, setDotCount] = useState(1);
  const navigate = useNavigate();
  // Updates the dot count
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dotString = ".".repeat(dotCount);

  // Changes icon after 2 seconds, then navigates after another 2 seconds (4 seconds total)
  useEffect(() => {
    // Change icon after 2 seconds
    const iconTimer = setTimeout(() => {
      changeIcon(icon2);
    }, 2000);

    // Navigate to results after 4 seconds total
    const navigationTimer = setTimeout(() => {
      console.log("Navigating to results screen");
      navigate("/seeresults");
    }, 4000);

    return () => {
      clearTimeout(iconTimer);
      clearTimeout(navigationTimer);
    };
  }, [navigate]);

  const changeIcon = (icon) => {
    setSelectedIcon(icon);
    setDisplayedText(t('aicom.selected', 'AICOM-chan has selected an image!'));
    setDisplayDots(false);
  };

  return (
    <div className={`${className}`} style={bgStyle}>
      <h1 className="text-black text-[40px] font-[700] pt-[128px] items-center text-center">
        {displayedText}
        {displayDots && <span className="inline-block w-12 text-left">{dotString}</span>}
      </h1>
      <img
        src={selectedIcon}
        alt={t('alt.aicomIcon', 'AICOM-chan icon')}
        className="absolute bottom-0 left-1/2 transform -translate-x-1/2"
      />
    </div>
  );
};

export default AIWaitingScreen;
